import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/../Assets/cv.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useTranslation } from "react-i18next";


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


function ResumeNew() {
  const [width, setWidth] = useState(1200);
  const { t } = useTranslation();

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);
  

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;{t("download_cv")}
          </Button>
        </Row>

        <Row className="resume">
          <Document file={pdf} className="flex-column align-items-center">
              <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} className="d-flex flex-column align-items-center"/>
              <Page pageNumber={2} scale={width > 786 ? 1.7 : 0.6} className="d-flex flex-column align-items-center"/>
          </Document>
        </Row>

        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;{t("download_cv")}
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
